// Marcas: Time Food (prato-relógio + linhas de velocidade) e Prefeitura de Magé.

export const TimeFoodMark = ({ size = 44 }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" fill="none" aria-hidden="true">
    <g>
      <path d="M6 44h34M0 60h30M8 76h32M18 30h24" stroke="#F7801E" strokeWidth="7" strokeLinecap="round" opacity="0.95" />
    </g>
    <circle cx="74" cy="60" r="42" fill="#F3F1EE" />
    <circle cx="74" cy="60" r="42" stroke="#DCD8D2" strokeWidth="2" />
    <circle cx="74" cy="60" r="30" fill="#FAF9F7" stroke="#E4E0DA" strokeWidth="2" />
    <path d="M74 22v6M74 92v6M36 60h6M106 60h6" stroke="#F7801E" strokeWidth="4" strokeLinecap="round" />
    {/* ponteiro garfo */}
    <path d="M74 60V37" stroke="#F7801E" strokeWidth="5" strokeLinecap="round" />
    <path d="M68 37v-9M74 37v-9M80 37v-9" stroke="#F7801E" strokeWidth="3.4" strokeLinecap="round" />
    {/* ponteiro faca */}
    <path d="M74 60l26-14" stroke="#F7801E" strokeWidth="6" strokeLinecap="round" />
    <circle cx="74" cy="60" r="5" fill="#F7801E" />
  </svg>
);

export const TimeFoodLogo = ({ size = 34, light = false, className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <TimeFoodMark size={size * 1.25} />
    <span className="font-display font-extrabold tracking-tight leading-none" style={{ fontSize: size * 0.66 }}>
      <span className={light ? "text-white" : "text-gf-black"}>TIME</span>
      <span className="text-gf-orange"> FOOD</span>
    </span>
  </div>
);

/** "Magé Time Food": cidade em azul-marinho + TIME (branco/preto) + FOOD (laranja). */
export const CityBrandWordmark = ({ city = "Magé", size = 20, light = false, accent = "#1F3864", className = "" }) => (
  <span className={`font-display font-extrabold tracking-tight leading-none ${className}`} style={{ fontSize: size }}>
    <span style={{ color: light ? "#9FC0EE" : accent }}>{city} </span>
    <span className={light ? "text-white" : "text-gf-black"}>TIME</span>
    <span className="text-gf-orange"> FOOD</span>
  </span>
);

export const MageCityLogo = ({ size = 64, showText = true }) => (
  <div className="flex flex-col items-center" aria-label="Prefeitura de Magé">
    <svg width={size} height={size * 0.86} viewBox="0 0 120 104" fill="none" aria-hidden="true">
      <path d="M60 100C36 84 8 66 8 40 8 22 21 10 36 10c10 0 18 5 24 13V100z" fill="#E53238" />
      <path d="M60 100c24-16 52-34 52-60 0-18-13-30-28-30-10 0-18 5-24 13V100z" fill="#1F3864" />
      <path d="M60 82C46 71 28 60 28 44c0-11 8-18 17-18 6 0 11 3 15 8 4-5 9-8 15-8 9 0 17 7 17 18 0 16-18 27-32 38z" fill="#FFFFFF" />
      <path d="M60 76C48 66 33 57 33 44c0-8 6-13 12-13 5 0 10 3 15 9 5-6 10-9 15-9 6 0 12 5 12 13 0 13-15 22-27 32z" fill="#2E8B57" />
      <path d="M60 68c-9-7-19-14-19-23 0-5 4-8 8-8 4 0 8 3 11 7 3-4 7-7 11-7 4 0 8 3 8 8 0 9-10 16-19 23z" fill="#F5C518" />
      <path d="M55 66c1.6-8 3.2-15 5-15s3.4 7 5 15z" fill="#2E8B57" />
    </svg>
    {showText && (
      <div className="mt-1 text-center leading-none">
        <div className="font-display font-extrabold text-mage-navy" style={{ fontSize: size * 0.3 }}>MAGÉ</div>
        <div className="tracking-[0.28em] text-mage-navy font-semibold" style={{ fontSize: size * 0.11 }}>PREFEITURA</div>
        <div className="h-[2px] bg-mage-green my-1 rounded-full" />
        <div className="font-script text-mage-navy" style={{ fontSize: size * 0.19 }}>Governando com Amor!</div>
      </div>
    )}
  </div>
);

/** Logo genérica de cidade (usada quando a cidade não é Magé). */
export const GenericCityLogo = ({ name = "Cidade", size = 64, accent = "#1F3864", logoUrl = null, showText = true }) => {
  if (logoUrl) {
    return <img src={logoUrl} alt={name} style={{ height: size, width: "auto" }} className="object-contain" />;
  }
  const initials = name.slice(0, 2).toUpperCase();
  return (
    <div className="flex flex-col items-center">
      <div
        className="rounded-2xl flex items-center justify-center font-display font-extrabold text-white"
        style={{ width: size, height: size * 0.86, background: accent, fontSize: size * 0.34 }}
      >
        {initials}
      </div>
      {showText && (
        <div className="mt-1 text-center leading-none">
          <div className="font-display font-extrabold" style={{ fontSize: size * 0.22, color: accent }}>
            {name.toUpperCase()}
          </div>
          <div className="tracking-[0.24em] font-semibold" style={{ fontSize: size * 0.1, color: accent }}>PREFEITURA</div>
        </div>
      )}
    </div>
  );
};

export const CityLogo = ({ city, size = 60, showText = true }) => {
  const name = city?.name || "Magé";
  if (name === "Magé") return <MageCityLogo size={size} showText={showText} />;
  return (
    <GenericCityLogo
      name={name}
      size={size}
      accent={city?.accent_color || "#1F3864"}
      logoUrl={city?.logo_url && city.logo_url.startsWith("http") ? city.logo_url : null}
      showText={showText}
    />
  );
};

export const CoBrandRow = ({ city, size = 60 }) => (
  <div className="flex items-center justify-center gap-5">
    <CityLogo city={city} size={size} />
    <div className="h-14 w-px bg-gray-300" />
    <TimeFoodLogo size={size * 0.6} />
  </div>
);
